import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { HijriYearPage } from "@/components/pages/HijriYearPage";
import { HIJRI_MONTHS_EN, parseHijriMonthSlug } from "@/lib/calendar/hijri";

export const Route = createFileRoute("/en/hijri-calendar/$hyear/")({
  beforeLoad: ({ params }) => {
    if (params.hyear.startsWith("$")) {
      throw notFound();
    }
  },
  loader: ({ params }) => {
    if (!/^\d+$/.test(params.hyear)) {
      const parsed = parseHijriMonthSlug(params.hyear);
      if (!parsed) throw notFound();
      throw redirect({
        to: "/en/hijri-calendar/$hyear/$hmonth/" as never,
        params: { hyear: String(parsed.hYear), hmonth: String(parsed.hMonth) },
      } as never);
    }
    const hYear = parseInt(params.hyear, 10);
    if (!Number.isFinite(hYear) || hYear < 1300 || hYear > 1600) throw notFound();
    return { hYear };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const y = loaderData.hYear;
    const title = `Hijri Calendar ${y} AH - Islamic Calendar with Gregorian Dates`;
    const desc = `Islamic (Hijri) calendar year ${y} AH with Gregorian dates and Indonesian public holidays. Months: ${HIJRI_MONTHS_EN.join(", ")}.`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
      ],
      links: [{ rel: "canonical", href: `https://hari.co.id/en/hijri-calendar/${y}/` }],
    };
  },
  component: () => {
    const { hYear } = Route.useLoaderData();
    return <HijriYearPage hYear={hYear} locale="en" />;
  },
  notFoundComponent: () => <div className="p-8 text-center">Invalid Hijri year.</div>,
  errorComponent: ({ error }) => <div className="p-8 text-center">Error: {error.message}</div>,
});